<template>
  <div>
    <div :class=" `chawgt-webchat-msg ${content.from === 'guest' ? 'chawgt-webchat-msg-right' : 'chawgt-webchat-msg-left' }` ">
      {{ content.title }}
    </div>
    <ul>
      <li v-for="(timeslot, index) in content.timeslots"
          v-bind:key="index">
        <span :class=" `chawgt-webchat-choice ${content.disabled === true ? 'chawgt-webchat-disabled' : ''}` "
              v-on:click="handleChoice(timeslot.identifier)">
          {{ timeslot.label }}
        </span>
      </li>
    </ul>
    <span class="chawget-msg-date">{{ formatDate(date) }}</span>
  </div>
</template>

<script>
import BaseMessage from '@/components/messages/BaseMessage.vue'

export default {
  name: 'Timeslots',
  extends: BaseMessage,
  methods: {
    handleChoice (timeslotIdentifier) {
      // console.log('CONTENT', this.content)
      if (this.content.disabled === false) {
        let label
        this.content.timeslots.forEach((timeslot) => {
          if (timeslot.identifier === timeslotIdentifier) {
            label = timeslot.label
          }
        })
        if (this.content.kind === 'timeslot') {
          const richContent = {
            kind: 'timeslot_choice',
            timeslot: {
              identifier: timeslotIdentifier,
              label: label
            }
          }
          this.$store.dispatch({
            type: 'sendMsg',
            content: this.content.content,
            richContent: richContent
          })
        } else {
          this.$store.dispatch({
            type: 'sendMsg',
            content: timeslotIdentifier,
            richContent: label
          })
        }
      }
      this.$store.commit(
        'disablePreviousChoices', timeslotIdentifier)
    }
  }
}
</script>

<style lang="scss" scoped>
// @import '@/components/widget.scss';
</style>
